var avalon = require("avalon"),
    $ = require("jquery"),
    ajax = require("ajax"),
    dialog = require("dialog"),
    tool = require("toolLoaderPC");

var vmodel = avalon.define({
    $id: "articleCreatController",

    jump: function(url) {
        ajax.pjax(url);
    }
});

export default {
    init: function() {
        // 发布帖子、回复
        $(".editor-container .public").on("click", "button", function(e) {
            var title = false;
            var input = $(".editor-container .subject input");
            if (input.length > 0) {
                title = $(".editor-container .subject input")
                    .val()
                    .replace("/^s+|s+$/g", "");
            }
            var id = $(".selectWrap select").val();
            var articleId = server.articleId;
            var url = "";
            var data = {};

            if (window.server.isEdit) {
                url = server.editUrl;
            } else {
                if (articleId > 0) {
                    url = server.replyUrl;
                    data = {
                        article_id: articleId,
                        content: ue.getContent(), // 编辑器获取内容
                        parent_reply_id: server.replyId,
                        ad_img : $('#ad_img').val()
                    };
                } else {
                    url = server.createUrl;
                    data = {
                        title: title,
                        group_id: id,
                        ad_img : $('#ad_img').val(),
                        content: ue
                            .getContent()
                            .replace(
                                /([\w\W\s\S]+)<p\sstyle="text-align:\scenter"><br\/><\/p>$/,
                                "$1"
                            )
                    };
                }
            }
            var content = ue.getContent();
            if (id == 0) {
                dialog.alert("请选择你要发布到的圈子！");
            } else if (title.length === 0 && title !== false) {
                dialog.alert("主题不能为空");
            } else if (title.length > 50) {
                dialog.alert("主题不能超过50个字");
            } else if (content.length === 0) {
                dialog.alert("内容不能为空");
            } else {
                dialog.confirm(
                    "确认提交吗？",
                    function() {
                        $.ajax({
                            url: url,
                            data: data,
                            type: "post"
                        }).done(function(res) {
                            if (res.code === 302) {
                                ajax.jump(window.server.loginUrl);
                            } else if (res.type === "err") {
                                dialog.alert(res.msg);
                            } else {
                                if (articleId > 0) {
                                    ajax.jump(server.articleUrl);
                                } else {
                                    ajax.jump(res.url);
                                }
                            }
                        });
                    },
                    function() {}
                );
            }
        });
    },
    clear: function() {}
};
